import { Routes } from '@angular/router';

import { HomeComponent, LoginComponent, LogoutComponent } from 'app/components';
import { authGuard } from 'app/shared/gaurds';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'logout', component: LogoutComponent, pathMatch: 'full' },
  { path: '', component: HomeComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: '' }
];
